<template lang="pug">
#app.layout.layout--cart
  .cart__wrapper
    .cart__header
      announcements-bar
      header-bar

    .cart__content
      nuxt
      footer-bar
  #footer
  cookie-consent-alert
</template>

<script>
import AnnouncementsBar from '~/components/menus/AnnouncementsBar'
import CatalogHeaderBar from '~/components/menus/CatalogHeaderBar'
import CatalogCartSider from '~/components/CatalogCartSider'
import LandingFooterBar from '~/components/menus/LandingFooterBar'
import CookieConsentAlert from '~/components/menus/CookieConsentAlert'

export default {
  name: 'CartLayout',

  components: {
    AnnouncementsBar,
    HeaderBar: CatalogHeaderBar,
    CartSider: CatalogCartSider,
    FooterBar: LandingFooterBar,
    CookieConsentAlert
  }
}
</script>
